import React from 'react';

import styles from './featuredIdeasListStyles';

import FeaturedIdeasListItem from './featuredIdeasListItem';

const FeaturedIdeasList = ({ featuredIdeas, handleClick, showUserDetails }) => {
  return (
    <div className={styles.featuredIdeasList}>
      {featuredIdeas.edges.map((edge, idx) => {
        return (
          <FeaturedIdeasListItem
            key={`${edge.node.id}-ranked${idx}`}
            idea={edge.node}
            idx={idx}
            handleClick={handleClick}
            showUserDetails={showUserDetails}
          />
        );
      })}
    </div>
  );
};

export default FeaturedIdeasList;
